var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-text',[_c('v-form',{model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[(_vm.schema)?_c('v-jsonschema-form',{attrs:{"schema":_vm.schema,"model":_vm.dataObject,"options":_vm.options}}):_vm._e(),_vm._v(" "),_c('v-btn',{on:{"click":_vm.submitHandler}},[_vm._v("submit")])],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/servers/add.vue?vue&type=template&id=4531f3fe&
// module id = null
// module chunks = 